import { createIntl, createIntlCache } from 'react-intl';

const cache = createIntlCache();

export const intl = createIntl({
  defaultLocale: 'en',
  locale: 'en',
  messages: {}
}, cache);
